"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutPage = void 0;
/* eslint-disable camelcase */
var react_1 = __importStar(require("react"));
var react_helmet_1 = require("react-helmet");
// import { useHistory } from 'react-router-dom'
var UserManager_1 = __importDefault(require("App/util/UserManager"));
var context_1 = require("App/context");
var Loader_1 = __importDefault(require("App/components/Loader"));
exports.LogoutPage = function () {
    var ctx = react_1.useContext(context_1.ApplicationContext);
    // const history = useHistory()
    react_1.default.useEffect(function () {
        console.log('Hootsuite App - removing user..');
        UserManager_1.default
            .removeUser()
            .then(function () {
            console.log('Hootsuite App - Logout');
            if (ctx !== undefined && ctx.extraQueryParams !== undefined) {
                window.sessionStorage.setItem('hootsuiteUserId', ctx.extraQueryParams.hootsuiteUserId);
                window.sessionStorage.setItem('hootsuiteTimestamp', ctx.extraQueryParams.hootsuiteTimestamp);
                window.sessionStorage.setItem('hootsuitePlacementId', ctx.extraQueryParams.hootsuitePlacementId);
                window.sessionStorage.setItem('hootsuiteToken', ctx.extraQueryParams.hootsuiteToken);
                window.sessionStorage.setItem('messageId', ctx.extraQueryParams.messageId);
            }
            var id_token_hint;
            if (ctx !== undefined && ctx.extraQueryParams !== undefined && ctx.extraQueryParams.hootsuiteUserId !== undefined) {
                console.log("hootsuite user id for logout: " + ctx.extraQueryParams.hootsuiteUserId);
                id_token_hint = ctx.extraQueryParams.hootsuiteUserId;
            }
            UserManager_1.default.signoutRedirect({ extraQueryParams: ctx.extraQueryParams, id_token_hint: id_token_hint }).catch(function (reason) {
                console.error('signoutRedirect() Error caught', reason);
            });
        })
            .catch(function (reason) {
            console.error('removeUser() Error caught:', reason);
        });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: "Logout" }),
        react_1.default.createElement(Loader_1.default, null)));
};
exports.default = {
    name: 'Logout',
    routeProps: {
        path: '/logout',
        component: exports.LogoutPage
    },
};
//# sourceMappingURL=logout.js.map